import * as StateLib from "@/Utils/StateLib";
import { Fragment } from "react";
import { Divider, ToolIcon } from "@theorgchartdev/storybook";
import { getHoverTipContent } from "@/Utils/Misc";
import { appstr } from "@coreapp/utils/appstr";

const BackgroundToolsComposite = () => {
  let wsMgr = StateLib.GetWSMgr();
  const DeleteBox = () => {
    wsMgr.fCanvasPanel.DeleteSelection();
    StateLib.ReRenderCanvas();
  };
  const firstSelectedBox = wsMgr.GetFirstSelectedBox(true);
  return (
    <Fragment>
      <ToolIcon
        dataTestId="background-editor-toolbar-remove-box-btn"
        name={"square-delete"}
        title={appstr("Remove box")}
        disabled={firstSelectedBox == null}
        onClick={DeleteBox}
        tooltipProps={getHoverTipContent("Delete box")}
      />
      <div className={"ocn-toolbar-horizontal-divider"}>
        <Divider vertical={true} />
      </div>
    </Fragment>
  );
};

export default BackgroundToolsComposite;
